import React from 'react';
import {LuFileQuestion} from 'react-icons/lu';

const NotFound = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <LuFileQuestion size={48} />
    </div>
  );
};

export default NotFound;
